import React from "react";
import { SEO } from "../components/seo";
import { graphql } from "gatsby";
import Container from "../components/container";
import CategoryLinkList from "../components/category-link-list";
import { mapEdgesToNodes, filterOutDocsWithoutSlugs } from "../lib/helpers";
import ProjectPreviewGrid from "../components/project/project-preview-grid";
import { Heading } from "theme-ui";

export const query = graphql`
  query CategoryTemplateQuery($id: String!, $currentDate: Date) {
    archive: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      archive {
        _id
        title
      }
    }
    category: sanityCategory(id: { eq: $id }) {
      id
      title
    }
    allProjects: allSanityProject(
      sort: { publishedAt: DESC }
      filter: { slug: { current: { ne: null } }, publishedAt: { ne: null, lte: $currentDate } }
    ) {
      totalCount
    }
    projects: allSanityProject(
      sort: { publishedAt: DESC }
      filter: {
        slug: { current: { ne: null } }
        publishedAt: { ne: null, lte: $currentDate }
        categories: { elemMatch: { id: { eq: $id } } }
      }
    ) {
      edges {
        node {
          _id
          publishedAt
          mainImage {
            asset {
              gatsbyImageData(fit: FILLMAX, placeholder: BLURRED, width: 450)
              title
              altText
            }
            hotspot {
              x
              y
            }
          }
          thumbImage {
            asset {
              gatsbyImageData(fit: FILLMAX, placeholder: BLURRED, width: 450)
              title
              altText
            }
            hotspot {
              x
              y
            }
          }
          title
          subtitle
          excerpt
          roles {
            fieldTitle
            fieldInfo
          }
          categories {
            title
          }
          slug {
            current
          }
        }
      }
    }
    usedCategories: allSanityProject(
      sort: { publishedAt: DESC }
      filter: { slug: { current: { ne: null } }, publishedAt: { ne: null } }
    ) {
      group(field: { categories: { title: SELECT } }) {
        totalCount
        fieldValue
      }
    }
    categories: allSanityCategory(filter: { projectFilter: { eq: true } }, sort: { title: ASC }) {
      edges {
        node {
          title
          id
          slug {
            current
          }
        }
      }
    }
  }
`;

const CategoryTemplate = (props) => {
  const { data, errors } = props;
  const category = data && data.category;

  const categoryNodes = data && data.categories && mapEdgesToNodes(data.categories);

  const projectNodes =
    data && data.projects && mapEdgesToNodes(data.projects).filter(filterOutDocsWithoutSlugs);

  const usedCategories = data && data.usedCategories;
  const archiveOrder = data && data.archive.archive;

  return (
    <>
      {errors && <SEO title="GraphQL Error" />}
      {category && <SEO title={category.title || "Untitled"} />}

      {errors && (
        <Container>
          <GraphQLErrorList errors={errors} />
        </Container>
      )}

      <Container
        sx={{
          textAlign: "center",
        }}
      >
        <Heading as="h1">{`Projects // ${category.title}`} </Heading>
        <CategoryLinkList
          categories={categoryNodes}
          currentCategory={category}
          all={true}
          used={usedCategories}
        />

        {projectNodes && projectNodes.length > 0 && (
          <ProjectPreviewGrid nodes={projectNodes} order={archiveOrder} />
        )}
      </Container>
    </>
  );
};

export default CategoryTemplate;

export const Head = ({ data }) => <SEO title={`Projects Tagged: ${data.category.title}`} />;
